<template>
	<div>
		<form action @submit.prevent="onSubmit">
			<form-errors :errors="errors"></form-errors>

			<field-errors v-if="submitAttempted" :form="$v.form" field="name"></field-errors>
			<div class="input-container">
				<div class="input-title">Module Name</div>
				<div class="input-box"><input v-model="form.name" type="text"></div>
			</div>

			<div class="input-container">
				<div class="input-title">Is External Module?</div>
				<div class="input-checkbox">
					<span class="checkmark-container">
						<label class="checkbox">
							<input type="checkbox" id="is_external" name="is_external" v-model="form.is_external">
							<span class="checkmark"></span>
						</label>
					</span>
					<label for="is_external" class="input-checkbox-text">Yes</label>
				</div>
			</div>

			<div v-if="form.is_external">
				<div class="input-container">
					<div class="input-title">Is Nav Heading Only?</div>
					<div class="input-checkbox">
					<span class="checkmark-container">
						<label class="checkbox">
							<input type="checkbox" id="is_nav_heading" name="is_nav_heading" v-model="form.is_nav_heading">
							<span class="checkmark"></span>
						</label>
					</span>
					<label for="is_nav_heading" class="input-checkbox-text">Yes</label>
					</div>
				</div>

				<div v-if="!form.is_nav_heading" class="input-container">
					<div class="input-title">IFrame URL</div>
					<div class="input-box"><input v-model="form.iframe" type="text"></div>
				</div>
			</div>

			<div v-if="!form.is_external">
				<field-errors v-if="submitAttempted" :form="$v.form" field="singular_name"></field-errors>
				<div class="input-container">
					<div class="input-title">Item Name</div>
					<div class="input-box"><input v-model="form.singular_name" type="text"></div>
				</div>
			</div>

			<div v-if="!(form.is_external && form.is_nav_heading)">
				<field-errors v-if="submitAttempted" :form="$v.form" field="slug"></field-errors>
				<div class="input-container">
					<div class="input-title">Module Slug</div>
					<div class="input-box"><slug-field v-model="form.slug" :base-field="form.name"></slug-field></div>
				</div>
			</div>

			<field-errors v-if="submitAttempted" :form="$v.form" field="icon"></field-errors>
			<div class="input-container">
				<div class="input-title">Fort Awesome Icon</div>
				<div class="input-box"><input v-model="form.icon" type="text"></div>
				<div class="input-box-icon"><span class="fa" :class="form.icon"></span></div>
			</div>

			<div v-if="!form.is_external">
				<div v-if="!isCuratedModule">
					<div class="input-container">
						<div class="input-title">Permissions</div>
						<div class="input-checkbox">
							<span class="checkmark-container">
								<label class="checkbox">
									<input type="checkbox" id="can-add" name="can-add" v-model="form.can_add">
									<span class="checkmark"></span>
								</label>
							</span>
							<label for="can-add" class="input-checkbox-text">Add</label>
						</div>
						<div class="input-checkbox">
							<span class="checkmark-container">
								<label class="checkbox">
									<input type="checkbox" id="can-update" name="can-update" v-model="form.can_edit">
									<span class="checkmark"></span>
								</label>
							</span>
							<label for="can-update" class="input-checkbox-text">Update</label>
						</div>
						<div class="input-checkbox">
							<span class="checkmark-container">
								<label class="checkbox">
									<input type="checkbox" id="can-delete" name="can-delete" v-model="form.can_delete">
									<span class="checkmark"></span>
								</label>
							</span>
							<label for="can-delete" class="input-checkbox-text">Delete</label>
						</div>
						<div class="input-checkbox">
							<span class="checkmark-container">
								<label class="checkbox">
									<input type="checkbox" id="can-view" name="can-view" v-model="form.can_view">
									<span class="checkmark"></span>
								</label>
							</span>
							<label for="can-view" class="input-checkbox-text">View/Manage</label>
						</div>
						<div class="input-checkbox">
							<span class="checkmark-container">
								<label class="checkbox">
									<input type="checkbox" id="can-copy" name="can-copy" v-model="form.can_copy">
									<span class="checkmark"></span>
								</label>
							</span>
							<label for="can-copy" class="input-checkbox-text">Copy</label>
						</div>
					</div>
				</div>

				<div v-if="!isCuratedModule" class="grid form two">
					<field-errors v-if="submitAttempted" :form="$v.form" field="plural_table_name"></field-errors>
					<div class="input-container">
						<div class="input-title">Plural Table Name</div>
						<div class="input-box"><input v-model="form.plural_table_name" type="text"></div>
					</div>

					<field-errors v-if="submitAttempted" :form="$v.form" field="singular_table_name"></field-errors>
					<div class="input-container">
						<div class="input-title">Singular Table Name</div>
						<div class="input-box"><input v-model="form.singular_table_name" type="text"></div>
					</div>

					<div class="input-container">
						<div class="input-title">Nested Module?</div>
						<div class="input-box">
							<selectize v-model="form.subtype" :settings="{ create: false }" placeholder="(Optional)">
								<option value="">No</option>
								<option value="submodule">Sub Module (Nested)</option>
								<option value="child">Child Module (Nested)</option>
							</selectize>
						</div>
					</div>

					<div v-show="isNestedModule" class="input-container">
						<div class="input-title">Parent Module</div>
						<div class="input-box">
							<selectize v-model="form.parent_module_id" :settings="{ create: false }" placeholder="Select Parent Module">
								<option v-for="parentModule in parentModules" :key="`parent-moduld-${ parentModule.id }`" :value="parentModule.id">{{ parentModule.name }}</option>
							</selectize>
						</div>
					</div>

					<field-errors v-if="submitAttempted" :form="$v.form" field="row_output_template" name="Row Output Template"></field-errors>
					<div class="input-container">
						<div class="input-title">Row Output Template</div>
						<div class="input-box"><input v-model="form.row_output_template" type="text" :placeholder="`Ex: {{ field_name }}`"></div>
					</div>

					<field-errors v-if="submitAttempted" :form="$v.form" field="sort"></field-errors>
					<div class="input-container">
						<div class="input-title">Column Sort{{ form.has_paging ? '*' : ''}}</div>
						<div class="input-box"><input v-model="form.sort" type="text" placeholder="Ex: field_slug ASC"></div>
					</div>

					<field-errors v-if="submitAttempted" :form="$v.form" field="has_paging"></field-errors>
					<div class="input-container">
						<div class="input-title">Enable Paging?</div>
						<div class="input-checkbox">
							<span class="checkmark-container">
								<label class="checkbox">
									<input type="checkbox" id="has-paging" name="has-paging" v-model="form.has_paging">
									<span class="checkmark"></span>
								</label>
							</span>
							<label for="has-paging" class="input-checkbox-text">Yes</label>
						</div>
					</div>

					<field-errors v-if="submitAttempted" :form="$v.form" field="form_style"></field-errors>
					<div class="input-container">
						<div class="input-title">Form Style</div>
						<div class="input-box"><input v-model="form.form_style" type="text" placeholder="Ex: Add class to form-content"></div>
					</div>

					<field-errors v-if="submitAttempted" :form="$v.form" field="searchable"></field-errors>
					<div class="input-container">
						<div class="input-title">Searchable?</div>
						<div class="input-box">
							<selectize v-model="form.searchable" :settings="{ create: false }" placeholder="Show Search Field?">
								<option :value="0">No</option>
								<option :value="1">Yes</option>
							</selectize>
						</div>
					</div>
				</div>

				<div class="title-container">
					<div class="title">Module Fields</div>
				</div>

				<div class="grid two has-complex-form" v-sortable="{ onUpdate: reorderFields, handle: '.input-dragger', scroll: true }">
					<base-field
						v-for="field in form.fields" :key="`field-${ field.id }`"
						:field="field"
						:module="module"
						@add-field="addField" @delete-field="deleteField"
					>
						<field v-show="!isReordering" :field="field" :fields="form.fields" :module="module" :parent-modules="parentModules"></field>
						<div v-show="isReordering" class="input-container">
							<div class="input-title">Field Name</div>
							<div class="input-static-text">{{ field.name }}</div>
						</div>
					</base-field>
				</div>
			</div>

			<div class="draft-status-bar-buffer"></div>
			<div class="draft-status-bar">
				<div v-if="!isSaving && hasErrors" class="draft-status bad-text"><span class="fa fa-exclamation-triangle"></span> Please correct errors above</div>
				<div v-else class="draft-status">Please save your changes</div>
				<div v-if="!isSaving" class="draft-button buttons">
					<a href @click.prevent="() => toggleReordering()" class="button" :class="{ 'good-text': isReordering }"><div class="hover-title">Toggle Reordering</div><span class="fa fa-list"></span></a>
					<a href @click.prevent="() => onSubmit()" class="button"><div class="hover-title">Save Module</div><span class="fa fa-save"></span></a>
				</div>
				<div v-if="isSaving" class="draft-button buttons"><a class="button disabled"><div class="hover-title">Processing</div><span class="fa fa-sync fa-spin"></span></a></div>
			</div>
		</form>
	</div>
</template>

<script>

import _ from 'underscore';
import { required, requiredIf } from 'vuelidate/lib/validators';
import BaseField from '../../../components/fields/BaseField';
import Field from '../../../components/fields/Field';
import FormMixin from '@/mixins/FormMixin';

export default {

	mixins: [FormMixin],

	props: {
		value: {
			type: Object,
			required: true,
		},
		module: {
			type: Object,
			default: () => ({}),
		},
		parentModules: {
			type: Array,
			required: true,
		},
		isSaving: {
			type: Boolean,
			default: false,
		},
	},

	data() {
		return {
			form: this.value,
			isReordering: false,
		};
	},

	watch: {

		value(newValue) {
			this.form = newValue;
			this.setUpForm();
		}

	},

	created() {
		this.setUpForm();
	},

	validations() {
		return {
			form: this.form.is_external
				? this.externalValidation()
				: (
					this.module.is_curated_module
						? this.curatedValidation()
						: this.standardValidation()
				),
		};
	},

	computed: {

		isNestedModule() {
			return [ 'submodule', 'child' ].indexOf(this.form.subtype) !== -1;
		},

		isCuratedModule() {
			return this.module.is_curated_module;
		},

	},

	mounted() {
		if (this.form.fields.length === 0) {
			this.addField();
		}
	},

	methods: {

		setUpForm() {
			for (let i = 0; i < this.form.fields.length; i++) {
				if (
					!this.form.fields[i].hasOwnProperty('config')
					|| !this.form.fields[i].config
					|| _.isArray(this.form.fields[i].config)
					|| !_.isObject(this.form.fields[i].config)
				) {
					this.$set(this.form.fields[i], 'config', {});
				}
			}
		},

		toggleReordering() {
			this.isReordering = !this.isReordering;
		},

		onSubmit() {
			this.submitAttempted = true;
			if (this.$v.$invalid !== true) {
				this.$emit('submitted');
			}
		},

		addField(fromField = null) {
			const index = _.indexOf(this.form.fields, fromField) || 0;
			const field = { id: _.uniqueId('field-'), new: true, config: {} };
			this.form.fields.splice(index+1, 0, field);

			return field;
		},

		deleteField(field) {
			if (field.new) {
				this.form.fields.splice(this.form.fields.indexOf(field), 1);
			} else {
				field.pendingDeletion = true;
			}

			this.ensureHasAtLeastOneStandardField();
		},

		reorderFields(event) {
			let fields = [ ...this.form.fields || [] ];
			fields.splice(event.newIndex, 0, fields.splice(event.oldIndex, 1)[ 0 ]);
			this.form.fields = [
				...fields || [],
			];
		},

		standardValidation() {
			return {
				name: { required },
				slug: { required },
				singular_name: { required },
				plural_table_name: { required },
				singular_table_name: { required },
				row_output_template: { required },
				parent_module_id: {
					required: requiredIf(model => {
						return ['submodule', 'child'].indexOf(model.subtype) !== -1;
					})
				},
				sort: {
					required: requiredIf(model => model.has_paging),
				},
			};
		},

		curatedValidation() {
			return {
				name: { required },
			};
		},

		externalValidation() {
			return {
				name: { required },
				slug: {
					required: requiredIf(model => {
						return !model.is_nav_heading;
					})
				},
				iframe: {
					required: requiredIf(model => {
						return !model.is_nav_heading;
					})
				},
			};
		},

	},

	components: {
		BaseField,
		Field,
	},

};

</script>
